//frontend/src/dropdownMap/1BAct8_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "SubActivity",
    11: "MusBuilt",
    15: "Gender",
    17: "PovertyLevel",
    18: "PWDStatus",
    20: "OMCommittee",
    21: "OMFundCollected",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    SubActivity: {
        internal: ["con_irr", "con_mus", "recon_irr", "recon_mus"],
        LA: {
            "con_irr": "ສ້າງຊົນລະປະທານ",
            "con_mus": "ສ້າງລະບົບນ້ຳ",
            "recon_irr": "ປັບປຸງຊົນລະປະທານ",
            "recon_mus": "ປັບປຸງລະບົບນ້ຳ"
        },
        EN: {
            "con_irr": "Construction of small scale irrigation system",
            "con_mus": "Construction of MUS",
            "recon_irr": "Reconstruction of small scale irrigation system",
            "recon_mus": "Reconstruction of MUS"
        }
    },

    MusBuilt: {
        internal: ["0", "1", "2"],
        LA: { "0": "ບໍ່ມີ", "1": "ສ້າງໃໝ່", "2": "ປັບປຸງຄືນ" },
        EN: { "0": "No", "1": "New", "2": "Renovated" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWDStatus: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    OMCommittee: {
        internal: ["comm_no", "comm_yes"],
        LA: { "comm_no": "ບໍ່ໄດ້ຕັ້ງ", "comm_yes": "ໄດ້ຕັ້ງ" },
        EN: { "comm_no": "No", "comm_yes": "Yes" }
    },

    OMFundCollected: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
